import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "specialPageDetail"
}
const _hoisted_2 = {
  key: 0,
  class: "error"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.readcms)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (this.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("strong", null, _toDisplayString(this.error), 1)
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (this.js_code != null)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    innerHTML: this.fullHtml
                  }, null, 8, _hoisted_3))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    innerHTML: this.fullHtml
                  }, null, 8, _hoisted_4))
            ], 64))
      ]))
    : _createCommentVNode("", true)
}